<template>
  <div>
    <v-main>
      <v-container>
        <v-row>
          <v-col>
            <h2>บัญชี</h2>
          </v-col>
          <v-col class="text-right">
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined v-bind="attrs" v-on="on">
                  <v-icon>mdi-book-open</v-icon>
                </v-btn>
              </template>
              <span>คู่มือการเลือกประเภท</span>
            </v-tooltip> -->

            <v-btn color="#1B437C" dark @click="dialogAdd = true"
              >เพิ่มบัญชี</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                  :loading="statusLoading"
                  :loading-text="textLoading"
                >
                <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                           @click.stop="Edit(item)"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="
                            ;(dialogDelete = true), getDataById(item)
                          "
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>

            <!-- dialog add -->
            <v-dialog v-model="dialogAdd" persistent max-width="40%">
              <v-card>
                <v-form ref="form" v-model="validAdd" lazy-validation>
                  <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <h2>สร้างบัญชี</h2>
                            </v-col>
                        </v-row>
                        <!-- <v-divider></v-divider> -->
                      <v-row>
                        <v-col style="padding: 10px 15px 0">
                          <p>ชื่อ <span style="color: red">*</span></p>
                          <v-text-field dense outlined v-model='formAdd.displayName' :rules="[rules.required]" ></v-text-field>
                          <p>Username <span style="color: red">*</span></p>
                          <v-text-field dense outlined v-model='formAdd.userName' :rules="[rules.email]"></v-text-field>
                          <p>Password <span style="color: red">*</span></p>
                          <v-text-field dense outlined v-model='formAdd.userPassword' :rules="[rules.required]"></v-text-field>
                          <p>ประเภทผู้ใช้ <span style="color: red">*</span></p>
                          <v-select dense outlined v-model='formAdd.userTypeGroup' :items='userType' :rules="[rules.required]"></v-select>
                          <p>สาขา</p>
                          <v-select dense outlined v-model='formAdd.masBranchID' :items='result_branch'></v-select>
                          <p>บริการ</p>
                          <v-select dense outlined hide-details v-model='formAdd.Exchangerate' :items='result_productexchangrate'></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                            <v-btn block dark color="red" @click="close">ยกเลิก</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn block dark color="#1B437C" @click="create">ยืนยัน</v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-form>
              </v-card>
            </v-dialog>
            <!-- dialog add -->

            <!-- dialog edit -->
            <v-dialog v-model="dialogEdit" persistent max-width="40%">
              <v-card>
                <v-form ref="form" v-model="validUpdate" lazy-validation>
                  <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <h2>แก้ไขบัญชี</h2>
                            </v-col>
                        </v-row>
                        <!-- <v-divider></v-divider> -->
                      <v-row>
                        <v-col style="padding: 10px 15px 0">
                          <p>ชื่อ <span style="color: red">*</span></p>
                          <v-text-field dense outlined v-model='formUpdate.displayName' :rules="[rules.required]" ></v-text-field>
                          <p>Username <span style="color: red">*</span></p>
                          <v-text-field dense outlined v-model='formUpdate.userName'></v-text-field>
                          <p>Password <span style="color: red">*</span></p>
                          <v-text-field dense outlined v-model='formUpdate.userPassword'></v-text-field>
                          <p>ประเภทผู้ใช้ <span style="color: red">*</span></p>
                          <v-select dense outlined v-model='formUpdate.userTypeGroup' :items='userType'></v-select>
                          <p>สาขา <span style="color: red">*</span></p>
                          <v-select dense outlined v-model='formUpdate.masBranchID' :items='result_branch'></v-select>
                          <p>บริการ</p>
                          <v-select dense outlined hide-details v-model='formUpdate.Exchangerate' :items='result_productexchangrate'></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                            <v-btn block dark color="red" @click="closeUpdate">ยกเลิก</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn block dark color="#1B437C" @click="update">ยืนยัน</v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-form>
              </v-card>
            </v-dialog>
            <!-- dialog edit -->

            <!-- dialog delete -->
            <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-container>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="ชื่อผู้ใช้"
                        v-model="formUpdate.displayName"
                        :rules="[rules.required]"
                        required
                        outlined
                        dense
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="formUpdate.userTypeGroup"
                        :items="userType"
                        attach
                        label="กลุ่มผู้ใช้งาน"
                        outlined
                        dense
                        readonly
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="clear()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-container>
            </v-card>
          </v-dialog>
            <!-- dialog delete -->
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date

export default {
  name: 'LoyaltyProdUser',

  data () {
    return {
      session: this.$session.getAll(),
      columns: [
        { text: 'ชื่อผู้ใช้', value: 'displayName' },
        { text: 'Username', value: 'userEmail' },
        { text: 'ประเภท', value: 'NEWuserTypeGroup' },
        { text: 'สาขา', value: 'newmasBranchName' },
        { text: 'บริการ', value: 'name' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      searchAll2: '',
      statusLoading: false,
      textLoading: '',
      dialogAdd: false,
      validAdd: true,
      dialogEdit: false,
      validUpdate: true,
      dialogDelete: false,
      formAdd: {
        displayName: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        userTypeGroup: '',
        shopId: '',
        masBranchID: '',
        CREATE_USER: '',
        LAST_USER: '',
        Exchangerate: ''
      },
      formUpdate: {
        displayName: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        userTypeGroup: '',
        shopId: '',
        masBranchID: '',
        CREATE_USER: '',
        LAST_USER: '',
        Exchangerate: ''
      },
      userType: [],
      result_branch: [],
      result_productexchangrate: [],
      result_checkMember: [],
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },

  mounted () {
    this.getEmployee()
    this.getBranch()
    this.getUserType()
    this.getProductExchangRate()
  },

  methods: {
    async getEmployee () {
      try {
        this.statusLoading = true
        this.textLoading = 'Loading... Please wait'
        await axios
          .get(this.DNS_IP + '/system_user/get?shopId=' + this.session.data.shopId)
          .then(res => {
            if (res.data.status === false) {
              this.dataItem = []
              this.textLoading = 'No data available'
            } else {
              this.dataItem = res.data.map((el) => {
                let newUserTypeGroup = ''
                let newmasBranchName = ''

                if (el.userTypeGroup === 'Shop Admin') {
                  newUserTypeGroup = 'ผู้จัดการ'
                } else if (el.userTypeGroup === 'cashier') {
                  newUserTypeGroup = 'แคชเชียร์'
                } else if (el.userTypeGroup === 'Operation') {
                  newUserTypeGroup = 'พนักงาน'
                } else if (el.userTypeGroup === 'partner') {
                  newUserTypeGroup = 'partner'
                }

                if (!el.masBranchName || el.masBranchName === null) {
                  newmasBranchName = 'ไม่ระบุ'
                } else {
                  newmasBranchName = el.masBranchName
                }

                // Add the newUserTypeGroup to each element
                return {
                  ...el,
                  NEWuserTypeGroup: newUserTypeGroup,
                  newmasBranchName: newmasBranchName
                }
              })

              console.log(this.dataItem)
              this.statusLoading = false
            }
          })
      } catch (error) {
        console.error('Error employees:', error)
      }
    },
    close () {
      this.$refs.form.reset()
      this.dialogAdd = false
    },
    async create () {
      try {
        if (this.$refs.form.validate()) {
          await this.checkUser()
          if (this.result_checkMember.length > 0) {
            this.$swal(
              'ไม่สำเร็จ',
              'username นี้มีอยู่ในระบบอยู่แล้ว',
              'error'
            )
            this.formAdd.userName = ''
          } else {
            // ไม่มี
            this.formAdd.shopId = this.session.data.shopId
            this.formAdd.CREATE_USER = this.$session.getAll().data.userName
            this.formAdd.LAST_USER = this.$session.getAll().data.userName
            this.formAdd.userEmail = this.formAdd.userName
            axios
              .post(this.DNS_IP + '/system_user/add', this.formAdd)
              .then(res => {
                console.log(res.data.status)
                if (res.data.status === true) {
                  this.$swal('สำเร็จ', 'บันทึกข้อมูลสำเร็จ', 'success')
                  this.getEmployee()
                  this.close()
                } else {
                  this.$swal('ไม่สำเร็จ', 'บันทึกข้อมูลไม่สำเร็จ', 'error')
                  this.getEmployee()
                  this.close()
                }
              })
          }
        }
      } catch (error) {
        console.error('Error:', error)
      }
    },
    checkUser () {
      try {
        axios
          .get(this.DNS_IP + '/system_user/get?shopId=' + this.session.data.shopId + '&userName=' + this.formAdd.userName)
          .then(res => {
            this.result_checkMember = []
            if (res.data.status === false) {
              this.result_checkMember = []
            } else {
              this.result_checkMember = res.data
            }
            console.log('result', this.result_checkMember)
            // return result
          })
      } catch (error) {
        console.log('error checkUser', error)
        return []
      }
    },
    getBranch () {
      try {
        axios
          .get(this.DNS_IP + '/master_branch/get?shopId=' + this.session.data.shopId)
          .then(res => {
            if (res.data.status === false) {
              this.result_branch = []
            } else {
              res.data.map(el => {
                el.text = el.masBranchName
                el.value = el.masBranchID
                this.result_branch.push(el)
              })
            }
          })
      } catch (error) {
        console.log('error getBranch', error)
        return []
      }
    },
    getUserType () {
      if (this.session.data.shopId === ('SD_1715763703870' || 'U438741aec10147b53a43abba10ddef68')) {
        // sunsaim
        this.userType = [
          {'text': 'ผู้จัดการ', 'value': 'Shop Admin'},
          {'text': 'แคชเชียร์', 'value': 'cashier'},
          {'text': 'partner', 'value': 'partner'}
        ]
      } else {
        // standard
        this.userType = [
          {'text': 'ผู้จัดการ', 'value': 'Shop Admin'},
          {'text': 'พนักงานหน้าร้าน', 'value': 'Operation'}
        ]
      }
    },
    getProductExchangRate () {
      try {
        axios
          .get(this.DNS_IP + '/productExchangeRate/get?shopId=' + this.session.data.shopId)
          .then(res => {
            this.result_productexchangrate = []
            if (res.data.status === false) {
              this.result_productexchangrate = []
            } else {
              res.data.map(el => {
                el.text = el.name
                el.value = el.productExchangeRateId
                this.result_productexchangrate.push(el)
              })
            }
          })
      } catch (error) {
        console.log('error getProductExchangRate', error)
      }
    },
    Edit (item) {
      this.dialogEdit = true
      console.log('item', item)
      Object.assign(this.formUpdate, item)
      if (this.formUpdate.masBranchID) {
        this.formUpdate.masBranchID = parseInt(this.formUpdate.masBranchID)
      }
      if (this.formUpdate.Exchangerate) {
        this.formUpdate.Exchangerate = parseInt(this.formUpdate.Exchangerate)
      }
      console.log('formedit', this.formUpdate)
    },
    closeUpdate () {
      this.$refs.form.reset()
      this.dialogEdit = false
    },
    update () {
      const ID = this.formUpdate['userId']
      delete this.formUpdate['CREATE_DATE']
      delete this.formUpdate['CREATE_USER']
      delete this.formUpdate['EXPIRY_DATE']
      delete this.formUpdate['LAST_DATE']
      delete this.formUpdate['LAST_USER']
      delete this.formUpdate['NEWuserTypeGroup']
      delete this.formUpdate['name']
      delete this.formUpdate['userId']
      delete this.formUpdate['productExchangeRateId']
      delete this.formUpdate['masBranchName']
      delete this.formUpdate['newmasBranchName']
      //   console.log('update', this.formUpdate)
      this.formUpdate.userEmail = this.formUpdate.userName
      axios
        .post(this.DNS_IP + '/system_user/edit/' + ID, this.formUpdate)
        .then(res => {
          if (res.data.status === false) {
            this.$swal('ไม่สำเร็จ', 'บันทึกข้อมูลไม่สำเร็จ', 'error')
            this.getEmployee()
            this.close()
          } else {
            this.$swal('สำเร็จ', 'บันทึกข้อมูลสำเร็จ', 'success')
            this.getEmployee()
            this.closeUpdate()
          }
        })
    },
    async getDataById (item) {
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        '/system_user/',
        'userId',
        item.userId
      )
      if (this.formUpdate.EXPIRY_DATE) {
        this.formUpdate.EXPIRY_DATE = moment(
          String(this.formUpdate.EXPIRY_DATE)
        ).format('YYYY-MM-DD')
      } else {
        this.formUpdate.EXPIRY_DATE = ''
      }
    },
    async deleteData () {
      console.log('DELETE PK : ', this.PK)
      let id = this.formUpdate.userId
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          await axios
            .post(
              this.DNS_IP + '/system_user/delete/' + id,
              this.formUpdate
            )
            .then(async response => {
              console.log('DNS_IP + PATH + "delete/"', response)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false
              this.dataReady = true
              this.getEmployee()
            })
        })
    },
    clear () {
      this.dialogDelete = false
      console.log('sds')
    }
  }
}
</script>
<style scoped>
p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/System/User.vue